import { render } from "./MenuLayout.vue?vue&type=template&id=de406212"
import script from "./MenuLayout.vue?vue&type=script&lang=js"
export * from "./MenuLayout.vue?vue&type=script&lang=js"
script.render = render

export default script